import React from 'react'
import Page from './Page'
import { List } from 'immutable'
import { Route } from 'react-router-dom'

const routesMap = {
  homepage: {
    pattern: '/',
    component: Page,
    exactly: true,
  },
  homepageTranslated: {
    pattern: '/:locale',
    component: Page,
  },
}

const routes = Object.keys(routesMap).map(key => routesMap[key])
export const links = {}
Object.keys(routesMap).forEach(key => { links[key] = routesMap[key].pattern })

export const MatchWithSubRoutes = (route) => (
  <Route
    {...route}
    render={(props) => (
      <route.component {...props} routes={route.routes} />
    )}
  />
)

export const flattenRoutes = (routes, components = new List()) => {
  const flattened = routes.reduce((routes, route) => {
    const routeComponents = components.push(route.component)
    routes = routes.concat([{ pattern: route.pattern, components: routeComponents.toJS() }])
    if (route.routes) routes = routes.concat(flattenRoutes(route.routes, routeComponents))
    return routes
  }, [])
  return flattened
}

export default routes



// WEBPACK FOOTER //
// ./src/browser/app/routes.js